import { IAdminConversationSummary, IAdminConversationMessage, IAdminConversationMessagesPage } from '../interfaces/heavyDutyMachinery/IAdminConversation';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

/** The caller's own admin-support conversation, if the team has ever opened one -- null (not thrown) when there is none yet, since that's the normal/common case, not an error. */
export const getMyAdminConversation = async (): Promise<IAdminConversationSummary | null> => {
  const response = await apiService<IAdminConversationSummary>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_MY_ADMIN_CONVERSATION,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  // MyAdminConversationController.GetMine's own 404 body -- the normal,
  // common "the team hasn't contacted this user yet" case, not an error the
  // caller should surface as one (see this function's own doc comment).
  // ApiResponse<T> carries no raw HTTP status to branch on directly, so this
  // matches the exact message that specific endpoint returns instead.
  if (response.error === 'Conversation not found') return null;
  throw new Error(response.error || 'Failed to load conversation');
};

export const getMyAdminConversationMessages = async (before?: number, limit?: number): Promise<IAdminConversationMessagesPage> => {
  const params: Record<string, string | number> = {};
  if (before != null) params.before = before;
  if (limit) params.limit = limit;
  const response = await apiService<IAdminConversationMessagesPage>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_MY_ADMIN_CONVERSATION_MESSAGES,
    method: HTTP_METHODS.GET,
    params,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load messages');
};

export const sendMyAdminConversationMessage = async (text: string): Promise<IAdminConversationMessage> => {
  const response = await apiService<IAdminConversationMessage>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_MY_ADMIN_CONVERSATION_MESSAGES,
    method: HTTP_METHODS.POST,
    body: { text },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to send message');
};

/** "Contactar con soporte" -- creates the caller's conversation if it's never existed, or reopens it if Closed, with this as its first/next message. See MyAdminConversationController.StartOrReopen. */
export const startMyAdminConversation = async (text: string): Promise<IAdminConversationSummary> => {
  const response = await apiService<IAdminConversationSummary>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_MY_ADMIN_CONVERSATION,
    method: HTTP_METHODS.POST,
    body: { text },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to start the conversation');
};
